<div class="loading-container"
  style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px; padding: 2rem;">
  <div *ngIf="!error()" class="loading-content" style="display: flex; flex-direction: column; align-items: center;">
    <i [class]="icon" style="font-size: 3rem; color: #007ad9; margin-bottom: 1rem;"></i>
    <h2 style="margin: 0 0 0.5rem 0;">{{ title }}</h2>
    <p style="margin: 0 0 1.5rem 0; color: #8a8a8a;">{{ message }}</p>
    <p-progressBar *ngIf="progress > 0 && progress < 100" [value]="progress"
      [style]="{'width': '250px', 'margin-bottom': '1rem'}"></p-progressBar>
    <div *ngIf="progress === 100" style="color: #28a745; margin-top: 0.5rem;">Terminé !</div>
  </div>
  <div *ngIf="error()" class="error-message"
    style="color: #d32f2f; background: #ffebee; padding: 1rem 2rem; border-radius: 6px; margin-top: 1rem; text-align: center;">
    <i class="pi pi-times-circle" style="font-size: 2rem; vertical-align: middle; margin-right: 0.5rem;"></i>
    {{ error() }}
  </div>
</div>